import React, { useCallback, useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import Avatar from '@pushpay/avatar';
import { Button } from '@pushpay/button';
import Drawer from '@pushpay/drawer';
import Dropdown from '@pushpay/dropdown';
import { ProfileSwitcherIcon } from '@pushpay/iconography';
import { clsx } from '@pushpay/styles';
import { useLink } from '../../link-provider';
import { Logout, LoggingOut } from './logout';
import { useStyles } from './styles';
export const DeprecatedProfileMenu = function DeprecatedProfileMenu(props) {
  const {
    classes: classesProp,
    profileId,
    firstName,
    lastName,
    emailAddress,
    profileImgUrl,
    profileLabel,
    profileLink,
    profilePath,
    personalAccountLabel,
    personalAccountLink,
    logoutLabel,
    loggingOutLabel,
    onLogout: onLogoutProp,
    isMobile = false,
    'data-pp-at-target': targetId,
    alignment,
    profileButtonAriaLabel,
    ...rest
  } = props;
  const [isMobileOverlayVisible, setIsMobileOverlayVisible] = useState(false);
  const classes = useStyles(classesProp);
  const [loggingOut, setLoggingOut] = useState(false);
  const onLogout = useCallback(() => {
    setLoggingOut(true);
    onLogoutProp();
  }, [onLogoutProp]);
  const summary = /*#__PURE__*/React.createElement(Avatar, {
    className: classes.avatar,
    id: profileId,
    name: [firstName, lastName],
    imgUrl: profileImgUrl,
    "data-pp-at-target": `${targetId}-avatar`
  });
  const {
    Link
  } = useLink();

  const overlay = close => /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.overlayContent
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classes.profileSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.avatarWrap
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: classes.profileSectionAvatar,
    id: profileId,
    name: [firstName, lastName],
    imgUrl: profileImgUrl,
    "data-pp-at-target": `${targetId}-profile-section-avatar`
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.profileInfoWrap
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx(classes.profileInfoOverflowHidden, classes.fullNameText)
  }, [firstName, lastName].join(' ')), /*#__PURE__*/React.createElement("span", {
    className: clsx(classes.profileInfoOverflowHidden, classes.emailText)
  }, emailAddress), profileLink && /*#__PURE__*/React.createElement(Link, {
    href: profileLink,
    title: profileLabel,
    className: classes.profileLink,
    "data-pp-at-target": `${targetId}-profile-link`
  }, profileLabel), profilePath && /*#__PURE__*/React.createElement(ReactRouterLink, {
    to: profilePath,
    onClick: close,
    title: profileLabel,
    className: classes.profileLink,
    "data-pp-at-target": `${targetId}-profile-path`
  }, profileLabel))), /*#__PURE__*/React.createElement("div", {
    className: classes.otherLinkSection
  }, /*#__PURE__*/React.createElement(Link, {
    href: personalAccountLink,
    title: personalAccountLabel,
    className: classes.personalAccountLink,
    target: "_blank",
    "data-pp-at-target": `${targetId}-personal-account-link`
  }, /*#__PURE__*/React.createElement(ProfileSwitcherIcon, {
    className: classes.profileSwitcherIcon,
    "data-pp-at-target": `${targetId}-profile-switcher-icon`
  }), /*#__PURE__*/React.createElement("span", null, personalAccountLabel))), /*#__PURE__*/React.createElement("div", {
    className: classes.otherLinkSection
  }, loggingOut ? /*#__PURE__*/React.createElement(LoggingOut, {
    label: loggingOutLabel,
    className: clsx(classes.textButton, classes.loggingOut),
    "data-pp-at-target": `${targetId}-loggingout`
  }) : /*#__PURE__*/React.createElement(Logout, {
    label: logoutLabel,
    onLogout: onLogout,
    className: clsx(classes.textButton, classes.logOut),
    "data-pp-at-target": `${targetId}-logout`
  })));

  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", {
      className: clsx(classes.root)
    }, /*#__PURE__*/React.createElement(Button, {
      classes: {
        root: classes.avatarButton
      },
      displayStyle: "unstyled",
      type: "button",
      onClick: () => setIsMobileOverlayVisible(true),
      "data-pp-at-target": `${targetId}-avatar-button-mobile`,
      "aria-label": profileButtonAriaLabel
    }, summary), /*#__PURE__*/React.createElement(Drawer, {
      classes: {
        drawer: classes.drawerMobile
      },
      visible: isMobileOverlayVisible,
      onClose: () => setIsMobileOverlayVisible(false),
      placement: "right",
      "data-pp-at-target": `${targetId}-mobile-overlay`
    }, overlay(() => setIsMobileOverlayVisible(false))));
  }

  return /*#__PURE__*/React.createElement(Dropdown, Object.assign({
    classes: {
      root: classes.root,
      summary: classes.avatarButton,
      overlay: classes.overlay
    },
    "data-pp-at-target": `${targetId}-avatar-button`,
    hideDropdownArrow: true,
    alignment: alignment,
    overlay: overlay,
    title: profileButtonAriaLabel,
    "aria-label": profileButtonAriaLabel
  }, rest), summary);
};